export const aggregateFunctions = [
  {
    value: 2,
    label: 'Sum',
  },
  {
    value: 3,
    label: 'Min',
  },
  {
    value: 4,
    label: 'Max',
  },
];

export const conditions = [
  {
    label: 'String | Integer',
    options: [
      { value: 'empty', label: 'is blank or empty', types: ['string', 'date', 'datetime', 'ENUM','ENUM2', 'user','EMAIL','file','VARCHAR(15)'] },
      { value: 'has value', label: 'is not blank (has value)', types: ['string', 'date', 'datetime', 'ENUM','ENUM2', 'user','EMAIL','file','VARCHAR(15)'] },
      { value: 'is equal', label: 'is equal', types: ['number', 'string', 'id','EMAIL','VARCHAR(15)'] },
      {
        value: 'is not equal',
        label: 'is not equal',
        types: ['number', 'string', 'id','EMAIL','VARCHAR(15)'],
      },
      { value: 'contain', label: 'contain', types: ['string','ENUM','ENUM2','EMAIL','VARCHAR(15)'] },
      { value: 'not contain', label: 'does not contain', types: ['string','ENUM','ENUM2','EMAIL','VARCHAR(15)'], hide:true },
      { value: 'start with', label: 'start with', types: ['string','EMAIL','VARCHAR(15)'] },
      { value: 'end with', label: 'end with', types: ['string','EMAIL','VARCHAR(15)'] },
    ],
  },
  {
    label: 'Number',
    options: [
      {
        value: 'greater than',
        label: 'greater than',
        types: ['number', 'id'],
      },
      {
        value: 'less than',
        label: 'less than',
        types: ['number', 'id'],
      },
      {
        value: 'greater than or equal to',
        label: 'greater than or equal to',
        types: ['number', 'id'],
      },
      {
        value: 'less than or equal to',
        label: 'less than or equal to',
        types: ['number', 'id'],
      },
      {
        value: 'greater than value in field',
        label: 'greater than value in field',
        types: ['number', 'id'],
      },
      {
        value: 'less than value in field',
        label: 'less than value in field',
        types: ['number', 'id'],
      },
      {
        value: 'greater than or equal to value in field',
        label: 'greater than or equal to value in field',
        types: ['number', 'id'],
      },
      {
        value: 'less than or equal to value in field',
        label: 'less than or equal to value in field',
        types: ['number', 'id'],
      },
    ],
  },
  {
    label: 'Boolean',
    options: [
      {
        value: 'true or false',
        label: 'true or false',
        types: ['boolean'],
      },
    ],
  },
  {
    label: 'Date',
    options: [
      {
        value: 'days_before_today',
        label: 'Days before today',
        types: ['date', 'datetime'],
      },
      {
        value: 'within_last_x_days',
        label: 'Within last days',
        types: ['date', 'datetime'],
      },
      { value: 'before_date', label: 'Before', types: ['date', 'datetime'] },
      {
        value: 'on_or_before_date',
        label: 'On or before',
        types: ['date', 'datetime'],
      },
      { value: 'after_date', label: 'After', types: ['date', 'datetime'] },
      {
        value: 'on_or_after_date',
        label: 'On or after',
        types: ['date', 'datetime'],
      },
      { value: 'between_date', label: 'Between', types: ['date', 'datetime'] },
      {
        value: 'not_between_date',
        label: 'Not between',
        types: ['date', 'datetime'],
      },
    ],
  },
  {
    label: 'Available Data',
    options: [
      {
        value: 'ccu',
        label: 'contains current user',
        types: ['enum', 'string', 'EMAIL','VARCHAR(15)']
      },
      {
        value: 'is equal to user',
        label: 'is equal to user',
        types: ['user','EMAIL'],
      },
      {
        value: 'currentuser',
        label: 'is current user',
        types: ['user', 'EMAIL'],
      },
      {
        value: 'equal to value in field',
        label: 'equal to value in field',
        types: [],
      },
      {
        value: 'not equal to value in field',
        label: 'not equal to value in field',
        types: [],
      },
    ],
  },
];

export const filterOptions = [
  {
    value: 'all',
    label: 'All of these conditions are true',
  },
  {
    value: 'any',
    label: 'Any of these conditions are true',
  },
];

export const columns = ['Column', 'Condition', 'Value', 'Actions'];

export const actionOptions = [
  // {
  //   label: 'Show',
  //   value: 'show',
  //   types: ['field','styleoption','button'],
  // },
  {
    label: 'Hide',
    value: 'hide',
    types: ['field','styleoption'],
  },
  {
    label: 'Require',
    value: 'require',
    types: ['field'],
  },
  // {
  //   label: 'Unrequire?',
  //   value: 'unrequire',
  //   types: ['field'],
  // },
  {
    label: 'Read Only',
    value: 'read_only',
    types: ['field'],
  },
  // {
  //   label: 'Editable',
  //   value: 'editable',
  //   types: ['field'],
  // },
  {
    label: 'UI Functionality',
    value: 'ui_functionality',
    types:[]
  },
  {
    label: 'Change Value',
    value: 'change_value',
    types: ['field'],
  },
]


export const dateOptions = [
  {
    value: 'year',
    label: 'In Year',
  },
  {
    value: 'month',
    label: 'In Month',
  },
  { value: 'before_date', label: 'Before', types: ['date', 'datetime'] },
  {
    value: 'on_or_before_date',
    label: 'On or before',
  },
  { value: 'after_date', label: 'After', types: ['date', 'datetime'] },
  {
    value: 'on_or_after_date',
    label: 'On or after',
  },
  { value: 'between_date', label: 'Between', types: ['date', 'datetime'] },
  {
    value: 'today',
    label: 'Today',
  },
]

export const stringOptions = [
  { value: 'empty', label: '(_blank)' },
  { value: 'is equal', label: 'is equal' },
  {
    value: 'is not equal',
    label: 'is not equal',
  },
  { value: 'contain', label: 'contain' },
  { value: 'start with', label: 'start with' },
  { value: 'end with', label: 'end with' },
]

export const intOptions = [
  { value: 'empty', label: '(_blank)' },
  { value: 'is equal', label: 'is equal' },
  {
    value: 'is not equal',
    label: 'is not equal',
  }
]

export const userConditions = [
  {label: 'Is in the Role', value: 'is_in_the_role'},
  {label: 'Is not in the Role', value: 'is_not_in_the_role'},
];
